import { Component, Input, ViewEncapsulation } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
    selector: 'app-custom-tooltip',
    templateUrl: './custom-tooltip.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class CustomTooltipComponent {
  @Input() title!: string;
  @Input() subtitle!: string;
}
